import { render, staticRenderFns } from "./ImageBG.vue?vue&type=template&id=1bc56294&scoped=true&"
import script from "./ImageBG.vue?vue&type=script&lang=js&"
export * from "./ImageBG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc56294",
  null
  
)

export default component.exports